import { Component, HostBinding, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/shared/material.module'
import { Select } from '@ngxs/store';
import { SalesProcessToolState } from '@app/shared/store/sales-process-tool/sales-process-tool.state';
import { SalesProcessNote } from '@app/models/sales-process-note';
import { SalesProcessNoteComponent } from './sales-process-note/sales-process-note.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-sales-process-tool',
  standalone: true,
  imports: [CommonModule, MaterialModule, SalesProcessNoteComponent],
  templateUrl: './sales-process-tool.component.html',
  styleUrls: ['./sales-process-tool.component.scss']
})
export class SalesProcessToolComponent implements OnInit {
  @Select(SalesProcessToolState.currentPageNotes())
  public unBrandedNotes$!: Observable<SalesProcessNote[]>
  @Select(SalesProcessToolState.currentPageBrandedNotes())
  public brandedNotes$!: Observable<SalesProcessNote[]>

  public displaySalesProcessTool: boolean = true;

  constructor() {}

  @HostBinding('class')
	public get klassList(): string {
		return this.displaySalesProcessTool ? 'm--full-height' : ''
	}

  ngOnInit(): void {}
}